.e2{background:var(--palette-white);}